// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.page .page-body {
    background-color: var(--page-background-color);
    color: var(--page-text-color);
}

@media (1600px <= width) {
    .page {
        display: grid;
        grid-template-columns: 400px auto 400px;
        width: 100%;
        max-width: 1600px;
        margin: 0 auto;
    }
}

@media (1220px < width < 1600px) {
    .page {
        display: grid;
        grid-template-columns: 1fr 800px 1fr;
        width: 100%;
        margin: 0 auto;
    }
}
@media (700px < width <= 1220px) {
    .page {
        display: grid;
        grid-template-columns: 1fr;
        grid-template-rows: auto;
        margin: 0 auto;
    }

    .page .page-left-gutter {
        grid-row: 2 / 3;
    }
    .page .page-right-gutter {
        grid-row: 1 / 2;
    }
    .page .page-body {
        box-sizing: border-box;
        margin: 0 auto;
        grid-row: 3 / 4;
        width: 100%;
        padding-top: 10px;
    }
}
@media (width <= 700px) {
    .page {
        display: grid;
        grid-template-columns: 1fr;
        grid-template-rows: auto;
        margin: 0 auto;
        padding: 0 5px;
    }

    .page .page-left-gutter {
        grid-row: 2 / 3;
    }
    .page .page-right-gutter {
        grid-row: 1 / 2;
    }
    .page .page-body {
        box-sizing: border-box;
        margin: 0 auto;
        grid-row: 3 / 4;
        width: 100%;
        padding-top: 10px;
    }
}
`, "",{"version":3,"sources":["webpack://./client/components/generic/Page.css"],"names":[],"mappings":"AAAA;IACI,8CAA8C;IAC9C,6BAA6B;AACjC;;AAEA;IACI;QACI,aAAa;QACb,uCAAuC;QACvC,WAAW;QACX,iBAAiB;QACjB,cAAc;IAClB;AACJ;;AAEA;IACI;QACI,aAAa;QACb,oCAAoC;QACpC,WAAW;QACX,cAAc;IAClB;AACJ;AACA;IACI;QACI,aAAa;QACb,0BAA0B;QAC1B,wBAAwB;QACxB,cAAc;IAClB;;IAEA;QACI,eAAe;IACnB;IACA;QACI,eAAe;IACnB;IACA;QACI,sBAAsB;QACtB,cAAc;QACd,eAAe;QACf,WAAW;QACX,iBAAiB;IACrB;AACJ;AACA;IACI;QACI,aAAa;QACb,0BAA0B;QAC1B,wBAAwB;QACxB,cAAc;QACd,cAAc;IAClB;;IAEA;QACI,eAAe;IACnB;IACA;QACI,eAAe;IACnB;IACA;QACI,sBAAsB;QACtB,cAAc;QACd,eAAe;QACf,WAAW;QACX,iBAAiB;IACrB;AACJ","sourcesContent":[".page .page-body {\n    background-color: var(--page-background-color);\n    color: var(--page-text-color);\n}\n\n@media (1600px <= width) {\n    .page {\n        display: grid;\n        grid-template-columns: 400px auto 400px;\n        width: 100%;\n        max-width: 1600px;\n        margin: 0 auto;\n    }\n}\n\n@media (1220px < width < 1600px) {\n    .page {\n        display: grid;\n        grid-template-columns: 1fr 800px 1fr;\n        width: 100%;\n        margin: 0 auto;\n    }\n}\n@media (700px < width <= 1220px) {\n    .page {\n        display: grid;\n        grid-template-columns: 1fr;\n        grid-template-rows: auto;\n        margin: 0 auto;\n    }\n\n    .page .page-left-gutter {\n        grid-row: 2 / 3;\n    }\n    .page .page-right-gutter {\n        grid-row: 1 / 2;\n    }\n    .page .page-body {\n        box-sizing: border-box;\n        margin: 0 auto;\n        grid-row: 3 / 4;\n        width: 100%;\n        padding-top: 10px;\n    }\n}\n@media (width <= 700px) {\n    .page {\n        display: grid;\n        grid-template-columns: 1fr;\n        grid-template-rows: auto;\n        margin: 0 auto;\n        padding: 0 5px;\n    }\n\n    .page .page-left-gutter {\n        grid-row: 2 / 3;\n    }\n    .page .page-right-gutter {\n        grid-row: 1 / 2;\n    }\n    .page .page-body {\n        box-sizing: border-box;\n        margin: 0 auto;\n        grid-row: 3 / 4;\n        width: 100%;\n        padding-top: 10px;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
